import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useSession } from '../context/SessionContext';

export default function useSkillController() {
  const { session } = useSession();
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSkills = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('skills')
        .select('*')
        .eq('user_id', session.user.id);

      if (error) throw error;
      setSkills(data);
    } catch (error) {
      console.error('Error fetching skills:', error);
      setError('Failed to fetch skills');
    } finally {
      setLoading(false);
    }
  };

  const addSkill = async (skillData) => {
    try {
      setLoading(true);
      const { error } = await supabase
        .from('skills')
        .insert([{
          ...skillData,
          user_id: session.user.id
        }]);

      if (error) throw error;
      await fetchSkills();
    } catch (error) {
      console.error('Error adding skill:', error);
      setError('Failed to add skill');
    } finally {
      setLoading(false);
    }
  };

  const updateSkill = async (id, skillData) => {
    try {
      setLoading(true);
      const { error } = await supabase
        .from('skills')
        .update(skillData)
        .eq('id', id);

      if (error) throw error;
      await fetchSkills();
    } catch (error) {
      console.error('Error updating skill:', error);
      setError('Failed to update skill');
    } finally {
      setLoading(false);
    }
  };

  const deleteSkill = async (id) => {
    try {
      setLoading(true);
      const { error } = await supabase
        .from('skills')
        .delete()
        .eq('id', id);

      if (error) throw error;
      await fetchSkills();
    } catch (error) {
      console.error('Error deleting skill:', error);
      setError('Failed to delete skill');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (session) fetchSkills();
  }, [session]);

  return {
    skills,
    loading,
    error,
    fetchSkills,
    addSkill,
    updateSkill,
    deleteSkill
  };
}